<template>
    <div v-if="isLoaded">
        <div class="content-body"
             v-bind:class="{ fullscreen_expand: isFullscreen }">
            <div class="row match-height">
                <div class="col-xl-12 col-lg-12">
                    <div class="card"
                         style="">
                        <div class="card-header">
                            <h4 class="card-title">Gerar Fatura</h4>
                            <a class="heading-elements-toggle"><i class="fa fa-ellipsis-v font-medium-3"
                                   @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"></i></a>
                            <div class="heading-elements"
                                 v-bind:class="{ visible: getSubMenuShowHideFw(), '': !getSubMenuShowHideFw() }">
                                <ul class="list-inline mb-0">
                                    <li><a @click="onCreate()"
                                           v-b-tooltip
                                           title="Gerar Fatura"
                                           v-if="getPermission('gerarfatura.store')"><i class="fa fa-print"></i></a></li>
                                    <li><a @click="onCreateFaturaLote()"
                                           v-b-tooltip
                                           title="Gerar Fatura em lote"
                                           v-if="getPermission('gerarfaturalote.store')"><i class="fa fa-print"></i></a></li>
                                    <li><a @click="expandFullscreen()"
                                           v-b-tooltip
                                           title="Expande a tela"
                                           v-if="!isFullscreen"><i class="ft-maximize"></i></a></li>
                                    <li><a @click="expandFullscreen()"
                                           v-b-tooltip
                                           title="Minimiza a tela"
                                           v-if="isFullscreen"><i class="ft-minimize"></i></a></li>
                                    <li><a @click="onFilterShowHide()"
                                           v-b-tooltip.hover.left="'Filtros'"><i class="fa fa-filter"></i></a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="card-content">
                            <div class="table-responsive">
                                <div v-if="vuetableFilterRow">
                                    <vuetable-filterbar>
                                    </vuetable-filterbar>
                                </div>
                                <div class="loadingDataPosition">
                                    <div class="loadingData"
                                         v-if="loadingData">
                                        <div class="loadingDataSpinner">
                                            <spinner v-if="loadingData"
                                                     text-fg-color="#ffffff"
                                                     message="Carregando..."></spinner>
                                        </div>
                                    </div>
                                    <vuetable ref="vuetable"
                                              api-url="/api/gerarfatura"
                                              :fields="fields"
                                              :css="css"
                                              :append-params="moreParams"
                                              track-by="doc_id"
                                              pagination-path=""
                                              @vuetable:pagination-data="onPaginationData"
                                              @vuetable:loaded="onLoaded">
                            <template slot="status" slot-scope="props">
                                <span class="badge badge-warning" v-if="props.rowData.status.valor==1">{{ props.rowData.status.descr }}</span>
                                <span class="badge badge-info" v-if="props.rowData.status.valor==2">{{ props.rowData.status.descr }}</span>
                                <span class="badge badge-success" v-if="props.rowData.status.valor==3">{{ props.rowData.status.descr }}</span>
                                <span class="badge badge-success" v-if="props.rowData.status.valor==4">{{ props.rowData.status.descr }}</span>
                                <span class="badge badge-danger" v-if="props.rowData.status.valor==5">{{ props.rowData.status.descr }}</span>
                                <span class="badge badge-danger" v-if="props.rowData.status.valor==6">{{ props.rowData.status.descr }}</span>
                                <span class="badge badge-danger" v-if="props.rowData.status.valor==7">{{ props.rowData.status.descr }}</span>
                                <span class="badge badge-danger" v-if="props.rowData.status.valor==8">{{ props.rowData.status.descr }}</span>
                              </template>
                              <template slot="modal" slot-scope="props">
                                  <span class="badge badge-secondary" v-if="props.rowData.b_modal.cd==1">{{ props.rowData.b_modal.descr }}</span>
                                  <span class="badge badge-info" v-if="props.rowData.b_modal.cd==2">{{ props.rowData.b_modal.descr }}</span>
                                  <span class="badge badge-secondary" v-if="props.rowData.b_modal.cd==3">{{ props.rowData.b_modal.descr }}</span>
                                  <span class="badge badge-default" v-if="props.rowData.b_modal.cd==4">{{ props.rowData.b_modal.descr }}</span>
                                  <span class="badge badge-danger" v-if="props.rowData.b_modal.cd==5">{{ props.rowData.b_modal.descr }}</span>
                                  <span class="badge badge-warning" v-if="props.rowData.b_modal.cd==6">{{ props.rowData.b_modal.descr }}</span>
                                </template>
                            </vuetable>
                                </div>
                                <div class='col-md-12'>
                                    <div class="pull-left pagination-detail">
                                        <vuetable-pagination-info ref="paginationInfo"
                                                                  :css="css.pagination"
                                                                  info-class="pull-left"></vuetable-pagination-info>
                                    </div>
                                    <div class="pull-right m-a-0">
                                        <vuetable-pagination ref="pagination"
                                                             :css="css.pagination"
                                                             @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <!-- Modal Component -->
                <b-modal id="modal_form"
                         ref="modal_form"
                         :title="modal_titulo"
                         :ok-title="modal_botao"
                         close-title="Fechar"
                         :ok-disabled=form.errors.any()
                         @ok="handleOk">
                <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">

                  <b-form-text>Total de documentos selecionados: {{ total_doc }}</b-form-text>

                  <b-form-text>Data de Vencimento</b-form-text>
                  <v-date-picker v-model="form.dt_vencto"
                                 mode='single'
                                 locale="pt-BR"
                                 v-mask="'##/##/####'"
                                 :popover='{visibility: "focus"}'
                                 :attributes='date_attributes'
                                 :input-props='{class: "form-control",placeholder: "dd/mm/yyyy"}'>
                  </v-date-picker>
                  <b-form-feedback class="text-danger" v-text="form.errors.get('dt_vencto')" v-if="form.errors.has('dt_vencto')"></b-form-feedback>
                  <b-form-text>Prazo tomador: {{ prazo_tomador }}</b-form-text>

                  <b-form-text>Observação</b-form-text>
                  <b-form-input type="text"
                                placeholder="Observação"
                                v-model="form.obs"
                                name="obs"
                                >
                  </b-form-input>
                  <b-form-feedback class="text-danger" v-text="form.errors.get('obs')" v-if="form.errors.has('obs')"></b-form-feedback>
                  <br/>
                  <small>* Caso a data de vencimento não seja informada, será utilizado a parametrização do cliente, adicioando o prazo a data atual.</small><br/>
                  <small>* Ao gerar fatura por esta opção, será gerado 1 fatura com todos CTE's selecionados.</small>
                </form>

                <div slot="modal-footer" class="w-100">
                       <div class="float-left"><spinner v-if="loading" message="Gerando..."></spinner></div>
                       <div class="float-right">
                           <b-btn @click="show=false" variant="secondary">
                             Cancelar
                           </b-btn>
                           <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                             Gerar Fatura
                           </b-btn>
                       </div>
                </div>
            </b-modal>
                <b-modal id="modal_form_lote"
                         ref="modal_form_lote"
                         :title="modal_titulo"
                         :ok-title="modal_botao"
                         close-title="Fechar"
                         showModal="true"
                         :ok-disabled=form.errors.any()
                         @ok="handleOkFaturaLote">
                <form @submit.stop.prevent="handleOkFaturaLote" @keydown="form.errors.clear($event.target.name)">

                  <b-form-text>Total de documentos selecionados: {{ total_doc }}</b-form-text>

                  <b-form-text>Data de vencimento</b-form-text>
                  <v-date-picker v-model="form.dt_vencto"
                                 mode='single'
                                 locale="pt-BR"
                                 v-mask="'##/##/####'"
                                 :popover='{visibility: "focus"}'
                                 :attributes='date_attributes'
                                 :input-props='{class: "form-control",placeholder: "dd/mm/yyyy"}'
                                 @keyup.enter="doFilter">
                  </v-date-picker>
                  <b-form-feedback class="text-danger" v-text="form.errors.get('dt_vencto')" v-if="form.errors.has('dt_vencto')"></b-form-feedback>

                  <b-form-text>Observação</b-form-text>
                  <b-form-input type="text"
                                placeholder="Observação"
                                v-model="form.obs"
                                name="obs"
                                >
                  </b-form-input>
                  <b-form-feedback class="text-danger" v-text="form.errors.get('obs')" v-if="form.errors.has('obs')"></b-form-feedback>
                  <br/>
                  <small>* Caso a data de vencimento não seja informada, será utilizado a parametrização do cliente, adicioando o prazo a data atual.</small><br/>
                  <small>* Ao gerar faturas em lote, será gerado 1 fatura para cada CTE com as informações acima.</small>
                </form>

                <div slot="modal-footer" class="w-100">
                       <div class="float-left"><spinner v-if="loading" message="Gerando..."></spinner></div>
                       <div class="float-right">
                           <b-btn @click="showModal=false" variant="secondary">
                             Cancelar
                           </b-btn>
                           <b-btn @click="handleOkFaturaLote($event)" variant="secondary" :disabled="isDisabled">
                             Gerar Fatura
                           </b-btn>
                       </div>
                </div>
            </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
    import Vuetable from '../components/Vuetable'
    import VuetablePagination from '../components/VuetablePagination'
    import VuetablePaginationInfo from '../components/VuetablePaginationInfo'
    import GerarFaturaFilterBar from './GerarFaturaFilterBar'
    import accounting from 'accounting'
    import moment from 'moment'

    export default {
        components: {
            Vuetable,
            VuetablePagination,
            VuetablePaginationInfo,
            'vuetable-filterbar': GerarFaturaFilterBar
        },
        data() {
            return {
                date_attributes: [{key: 'today',highlight: true,dates: new Date()}],
                modal_titulo: '',
                modal_botao: '',
                modal_acao: '',
                loading: false,
                isDisabled: false,
                loadingData: true,
                showModal: false,
                isFullscreen: false,
                total_doc: 0,
                prazo_tomador: '',
                doc_id: '',
                helpForm: new Form({
                    statusRecord: [],
                    params: []
                }),
                form: new Form({
                    obs: '',
                    dt_vencto: '',
                    doc_id: []
                }),
                fields: [{
                        name: '__checkbox',
                        titleClass: 'center aligned',
                        dataClass: 'center aligned'
                    },
                    {
                        name: 'num_controle',
                        title: 'Nº Controle'
                    },
                    {
                        name: 'num_fiscal',
                        title: 'N° Fiscal'
                    },
                    {
                        name: 'serie',
                        title: 'Série'
                    },
                    {
                        name: 'dt_emi',
                        title: 'Data Emissão',
                        callback: 'formatDate|DD/MM/YYYY'
                    },
                    {
                        name: '__slot:modal',
                        title: 'Modal'
                    },
                    {
                        name: 'vlr_receber',
                        title: 'Valor á Receber',
                        callback: 'formatNumber'
                    },
                    {
                        name: 'vlr_prestacao',
                        title: 'Valor CTE',
                        callback: 'formatNumber'
                    },
                    {
                        name: '__slot:status',
                        title: 'Status Documento'
                    },
                    {
                        name: 'doc_cte_partes_env.tom_nome',
                        title: 'Tomador'
                    },
                ],
                css: {
                    tableClass: 'table table-striped',
                    loadingClass: 'loading',
                    ascendingIcon: 'glyphicon glyphicon-chevron-up',
                    descendingIcon: 'glyphicon glyphicon-chevron-down',
                    handleIcon: 'glyphicon glyphicon-menu-hamburger',
                },
                moreParams: {}
            }
        },
        mounted() {
            this.$events.$on('filter-set', eventData => this.onFilterSet(eventData));
            this.$events.$on('filter-reset', e => this.onFilterReset());
        },
        methods: {
            onPaginationData(paginationData) {
                this.$refs.pagination.setPaginationData(paginationData)
                this.$refs.paginationInfo.setPaginationData(paginationData)
            },
            onChangePage(page) {
                this.$refs.vuetable.changePage(page)
            },
            formatDate(value, fmt = 'D/MM/YYYY HH:mm') {
                return (value == null) ?
                    '' :
                    moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
            },
            formatNumber(value) {
                return accounting.formatNumber(value, 2, '.', ',')
            },
            onFilterSet(data_filter) {
                this.loadingData = true;
                this.moreParams = {
                    'num_fiscal': data_filter.num_fiscal,
                    'num_controle': data_filter.num_controle,
                    'dt_emi': data_filter.dt_emi,
                    'tom_nome': data_filter.tom_nome,
                    'tom_ie': data_filter.tom_ie,
                    'tom_cnpj': data_filter.tom_cnpj,
                    'chave_cte': data_filter.chave_cte,
                    'status': data_filter.status.value
                }
                Vue.nextTick(() => this.$refs.vuetable.refresh())
            },
            onFilterReset() {
                this.loadingData = true;
                this.moreParams = {}
                Vue.nextTick(() => this.$refs.vuetable.refresh())
            },
            onFilterShowHide() {
                if (this.vuetableFilterRow) {
                    this.$store.commit('setVuetableFilterRow', false);
                } else {
                    this.$store.commit('setVuetableFilterRow', true);
                }
            },
            onLoaded: function() {
                this.dataExport = this.$refs.vuetable.tableData;
                this.loadingData = false;
                this.$store.commit('setVuetableFilterButton', false);
            },
            handleOk(e) {
                e.preventDefault();
                if (this.modal_acao == "i") {
                    this.onStore();
                } else {
                    this.onUpdate(this.form.parareemp_id);
                }
            },
            onCreate(data) {
                this.modal_titulo = "Gerar Fatura";
                this.modal_botao = "Gerar Fatura"; // OK
                this.modal_acao = "i";
                this.form.reset();
                this.form.doc_id = '';
                this.form.doc_id = [];
                this.total_doc = 0;

                // Vericando dias
                var doc_id_first;
                var add_days;
                this.$refs.vuetable.selectedTo.forEach((obj) => {
                    if (doc_id_first == undefined) {
                        doc_id_first = obj;
                    }
                    this.form.doc_id.push({
                        id: obj
                    });
                    this.total_doc = this.total_doc + 1;
                });

                this.$refs.vuetable.tableData.forEach((obj) => {
                    if (doc_id_first == obj.doc_id) {
                        add_days = obj.doc_cte_partes_env.pessoa_tom.pessoa_financeiro.prazo_pagamento;
                        this.prazo_tomador = obj.doc_cte_partes_env.pessoa_tom.pessoa_financeiro.prazo_pagamento;
                    }
                });

                if (add_days != undefined) {
                    var today = new Date();
                    var new_date = new Date();
                    new_date.setDate(today.getDate() + parseInt(add_days));
                    this.form.dt_vencto = this.formatDate(new_date, 'DD/MM/YYYY');
                }
                this.$refs.modal_form.show();
            },
            onStore() {
                this.loading = true;
                this.isDisabled = true;
                this.$refs.vuetable.selectedTo = [];
                this.form.dt_vencto = this.formatDateSubmit(this.form.dt_vencto);
                this.form.post('/api/gerarfatura/gerar').then(response => {
                        new ReturnApi(response, this);
                        Vue.nextTick(() => this.$refs.vuetable.reload());
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            handleOkFaturaLote(e) {
                e.preventDefault();
                if (this.modal_acao == "i") {
                    this.onStoreFaturaLote();
                } else {
                    this.onUpdateFaturaLote(this.form.parareemp_id);
                }
            },
            formatDateSubmit (value, fmt = 'DD/MM/YYYY') {
                return (value == null || value == "")
                  ? ''
                  : moment(value, 'YYYY/MM/DD HH:mm').format(fmt)
            },
            expandFullscreen() {
                this.isFullscreen = !this.isFullscreen;
            },
            onCreateFaturaLote(data) {
                this.modal_titulo = "Gerar Fatura";
                this.modal_botao = "Gerar Fatura"; // OK
                this.modal_acao = "i";
                this.form.reset();
                this.form.doc_id = '';
                this.form.doc_id = [];
                this.total_doc = 0;
                this.$refs.vuetable.selectedTo.forEach((obj) => {
                    this.form.doc_id.push({
                        id: obj
                    });
                    this.total_doc = this.total_doc + 1;
                });
                this.$refs.modal_form_lote.show();
            },
            onStoreFaturaLote() {
                this.loading = true;
                this.isDisabled = true;
                this.$refs.vuetable.selectedTo = [];
                this.form.dt_vencto = this.formatDateSubmit(this.form.dt_vencto);
                this.form.post('/api/gerarfaturalote/gerar').then(response => {
                        new ReturnApi(response, this);
                        Vue.nextTick(() => this.$refs.vuetable.reload());
                    })
                    .catch(errors => {
                        new ReturnApi(errors, this)
                    });
            },
            getPermission(checkPermission) {
                return this.getPermissionFw(checkPermission);
            },
        },
        computed: {
            vuetableFilterRow: {
                get() {
                    return this.$store.getters.vuetable.filterRow;
                },
            },
            isLoaded: {
                get() {
                    return this.$store.getters.isloaded;
                }
            }
        }
    }

</script>
